import { Input } from '@wove/web-ui'
import InviteUserModal from '@src/Components/InviteUserModal'
import { Search } from 'lucide-react'

const HeaderControls = ({
  searchText,
  setSearchText,
}: {
  searchText: string
  setSearchText: (text: string) => void
}) => {
  return (
    <div className="flex gap-5">
      <div className="flex-[1_1_0]">
        <Input
          placeholder="Search..."
          iconLeft={<Search />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <InviteUserModal />
    </div>
  )
}

export default HeaderControls
